import {Pipe, PipeTransform} from "@angular/core";
import {DecimalPipe} from "@angular/common";

@Pipe({name: 'numberPrefix'})
export class NumberPrefix implements PipeTransform {

  constructor (private decimalPipe: DecimalPipe) {

  }

  prefix_ranges = [
    {
      prefix: 'K',
      value: 1000
    },
    {
      prefix: 'M',
      value: 1000000
    },
    {
      prefix: 'G',
      value: 1000000000
    }
  ]

  findPrefix(value: number): any {

    let p = this.prefix_ranges.find(r => {
      let ratio = Math.abs(value) / r.value
      return ratio > 1 && ratio < 1000
    })


    if (p == null || !p) {
      return {
        prefix: '',
        value: 1
      };
    } else return p;

  }

  transform(value: any, digits?: string, locale?: string): string {

    let p = this.findPrefix(parseFloat(value))
    return this.decimalPipe.transform((value / p.value), digits, locale) + p.prefix;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/pipes/NumberPrefix.ts